import { useVersion } from '@ihs-widget/utils/hooks/useVersion';
import { useEffect, useRef } from 'react';
import { getIsIPhone, getIsAndroid } from '@ihs-widget/utils/functions';

interface FilterButtonProps {       
    text: string;
    isActive: boolean;
    onClick: () => void;
    additionalClassName?: string;
    disabled?: boolean;
    id?: string;
}

export default function FilterButton({
    text, 
    isActive, 
    onClick, 
    additionalClassName, 
    disabled = false,
    id
}: FilterButtonProps) {
    const { isV1 } = useVersion();
    const filterButtonRef = useRef<HTMLDivElement>(null);
    const isIPhone = getIsIPhone();
    const isAndroid = getIsAndroid();
    const shouldDisableHover = isIPhone || isAndroid;

    const scrollFilterIntoView = () => {
        const containerElement = document.querySelector('.menuItemsStats-disable-scrollbar');
        const filterElement = document.querySelector(`[data-filter-id="${id || text}"]`);

        if (containerElement && filterElement) {
            const containerRect = containerElement.getBoundingClientRect();
            const filterRect = filterElement.getBoundingClientRect();

            const isPartiallyVisible = 
                filterRect.left < containerRect.left || 
                filterRect.right > containerRect.right;

            if (isPartiallyVisible) {
                const scrollLeft = filterRect.left - containerRect.left + containerElement.scrollLeft;
                
                containerElement.scrollTo({
                    left: scrollLeft - 16,
                    behavior: 'smooth'
                });
            }
        }
    }

    const handleClick = () => {
        if (!disabled) {
            onClick();
            scrollFilterIntoView();
        }
    }

    useEffect(() => {
        if (isActive) {
            setTimeout(() => {
                scrollFilterIntoView();
            }, 100);
        }
    }, [isActive]);

    return (
        <div 
            ref={filterButtonRef}
            data-testid={id || text}
            data-filter-id={id || text}
            className={`border rounded-[32px] px-[16px] 
                        flex justify-center items-center
                        ${disabled ? 'cursor' : 'cursor-pointer'}
                        font-robotoMedium font-medium 
                        text-[12px] leading-[16px] align-middle
                        text-nowrap whitespace-nowrap
                        ${additionalClassName}
                        ${disabled && !isActive ? 
                            `opacity-50 bg-monoY dark:bg-base110 border-base090 dark:border-base0 text-base0 dark:text-base090` 
                            : disabled && isActive ?
                            `opacity-50 bg-brand080 dark:bg-brand120 border-brand110 dark:border-brand110 text-base120 dark:text-monoY`
                            : !disabled && isActive ? 
                            `bg-brand080 dark:bg-brand120 border-brand110 dark:border-highlight-dark text-base120 dark:text-monoY 
                            ${!shouldDisableHover ? 'hover:text-highlight-light dark:hover:text-success120' : ''}
                            ` 
                            : 
                            `bg-monoY dark:bg-base110 border-base090 dark:border-base0 text-base0 dark:text-base090
                             ${!shouldDisableHover ? 'hover:bg-brand080 dark:hover:bg-brand120 hover:border-brand110 dark:hover:border-highlight-dark hover:text-highlight-light dark:hover:text-success120' : ''}`}
                        `}
            style={{ height: isV1 ? '20px' : '23px', lineHeight: isV1 ? '20px' : '23px' }}
            onClick={handleClick}>
            {text}
        </div>
    )
}